import { App, Button, Card } from 'antd';
import { Achievement, ActionDto } from '../../../../dto/reporting-models';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { AchievementForm } from './achievement-form';
import { strings } from '../../../../lang';

type AchievementCardParams = {
  achievement: Achievement;
  actionsInfo: ActionDto[];
  onSubmit: (rule: Achievement) => void;
  shouldDisplayAddButton: (status: boolean) => void;
  deleteAchievement: (achievementId: number) => void;
};

export const AchievementCard = ({ achievement, actionsInfo, onSubmit, shouldDisplayAddButton, deleteAchievement }: AchievementCardParams) => {
  const { modal } = App.useApp();
  const [shouldEdit, setShouldEdit] = useState(false);

  const cancelEdit = () => {
    setShouldEdit(false);
    shouldDisplayAddButton(true);
  };

  const showDeleteConfirm = () => {
    modal.confirm({
      title: strings.gamificationSettings.achievements.deleteConfirmationTitle,
      icon: <DeleteOutlined />,
      content: strings.gamificationSettings.achievements.deleteConfirmationDescription,
      okText: strings.gamificationSettings.achievements.yes,
      okType: 'danger',
      cancelText: strings.gamificationSettings.achievements.no,
      onOk() {
        deleteAchievement(achievement.id);
      },
    });
  };

  return (
    <Card className="achievement-card">
      {shouldEdit ? (
        <AchievementForm
          achievement={achievement}
          actions={actionsInfo}
          onSubmit={(achievement: Achievement) => {
            onSubmit(achievement);
            setShouldEdit(false);
          }}
          cancel={cancelEdit}
        />
      ) : (
        <div className="achievement-card__content">
          {achievement.icon ? (
            <img className="achievement-card__icon" src={decodeURIComponent(achievement.icon)} alt={strings.gamificationSettings.achievements.iconAlt} />
          ) : (
            <div className="achievement-card__icon achievement-card__icon--placeholder" role="img" aria-label={strings.gamificationSettings.achievements.iconPlaceholderAlt} />
          )}
          <div className="achievement-card__details">
            <div className="achievement-card__heading">
              <h3>{achievement.name}</h3>
              <div className="achievement-card__actions">
                <Button
                  onClick={() => {
                    setShouldEdit(true);
                    shouldDisplayAddButton(false);
                  }}
                  icon={<EditOutlined />}
                >
                  {strings.gamificationSettings.achievements.edit}
                </Button>
                <Button danger onClick={showDeleteConfirm} icon={<DeleteOutlined />}>
                  {strings.gamificationSettings.achievements.delete}
                </Button>
              </div>
            </div>
            <p>{achievement.description}</p>
          </div>
        </div>
      )}
    </Card>
  );
};
